<template>
    <v-container>
        <v-row justify="start" >
            <v-col cols="12" v-if="checkDialog== false">
                <v-card>
                    <v-card-title>
                        <v-col cols="12" xl="2" lg="3" md="4" sm="6" xs="6">
                            <h1>Sensor Modeling</h1>
                        </v-col>
                        <v-spacer/>
                        <v-col cols="1">
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn                                         
                                        icon
                                        :loading="btn_loading"
                                        @click="fresh_sensor()" 
                                        v-bind="attrs" 
                                        v-on="on"
                                    >
                                        <v-icon>mdi-cached</v-icon>
                                    </v-btn>
                                </template>
                                <span style="font-size: 16px;">Get latest sensor model list</span>
                            </v-tooltip>
                        </v-col>
                    </v-card-title>
                    <v-card-title>
                        <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table :headers="headers" :items="table_data" :search="search" class="elevation-1">
                        <template v-slot:item.detail="{item}">
                            <a>
                                <span @click="detail(item)">detail</span>
                            </a>
                        </template>
                          <template v-slot:item.in_set="{item}">
                            <v-btn class="mt-3" color="primary" @click="update(item); edit_status=true">Edit</v-btn>
                            <v-btn v-if="item.inter_active == false" class="ml-1 mt-3 " color="error" @click="activeSensor(item, true, 'internal')">Inactive</v-btn>
                            <v-btn v-if="item.inter_active == true" class="ml-5 mt-3" color="success" @click="activeSensor(item, false, 'internal')">Active</v-btn>
                        </template>
                        <template v-slot:item.ex_set="{item}">
                           
                            <v-btn v-if="item.exter_active == false" class="ml-3 mt-3" color="error" @click="activeSensor(item, true, 'external')">Inactive</v-btn>
                            <v-btn v-if="item.exter_active == true" class="ml-3 mt-3" color="success" @click="activeSensor(item, false, 'external')">Active</v-btn>
                        </template>
                      
                        <template v-slot:item.created_at="{item}">
                            {{ item.created_at | moment}}
                        </template>
                        <template v-slot:item.update_at="{item}">
                            {{ item.update_at | moment}}
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
            <v-col cols="12" v-if="checkDialog==true">
                <v-card>
                    <v-card-title primary-title>
                        <v-row>
                            <v-col>
                                Sensor Model: &nbsp;{{ data.model_name }}
                            </v-col>
                            <v-spacer/>
                            
                            <v-col cols="1">
                                <v-btn style="background: grey; color: white" @click="back()">Back</v-btn>
                            </v-col>
                        </v-row>
                        
                    </v-card-title>
                    <v-card-text style="margin-top: -30px;">
                        <v-row>
                            <v-col cols="12" xl="3" lg="3" md="3" sm="12">
                    
                                <div class="borderStyle" >
                                    <h1>Capacitance</h1>
                                    <v-row v-for="(item, idx) in data.sensor_capacitance" :key="idx">
                                        <v-col cols="1">
                                            <v-checkbox v-model="item.default" @click="chooseDefault(idx, 'capacitance')"></v-checkbox>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-text-field v-model="item.analog_gain" label="Analog gain:" :rules="[rules.emptyRules]" outlined></v-text-field> 
                                        </v-col>
                                        <v-divider class="mt-10" horizon/>
                                        <v-col cols="4">
                                            <v-text-field v-model="item.capacitance_fF" type="Number" min="0" step="1" label="Capacitance:" :rules="[rules.emptyRules, rules.minNumber]" outlined></v-text-field>                                                                   
                                        </v-col>
                                        <v-col>
                                            <v-icon style="margin-top: 19px;" @click="removeCapacitance(idx)">mdi-close</v-icon>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" v-if="data.sensor_capacitance.length > 0">
                                            <span>*Please choose default with checkbox </span>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-btn style="width: 100%;" color="primary" @click="addCapacitance()">ADD</v-btn>
                                        </v-col>
                                    </v-row>
                                </div>
                            </v-col>
                            <v-col cols="12" xl="3" lg="3" md="3" sm="12">
                    
                                <div class="borderStyle" >
                                    <h1>Demodulation Frequency</h1>
                                    <v-row v-for="(item, idx) in data.sensor_demod_frequency" :key="idx">
                                        <v-col cols="2">
                                            <v-checkbox v-model="item.default" @click="chooseDefault(idx, 'demod_frequency')"></v-checkbox>
                                        </v-col>
                                        <v-col cols='6'>
                                            <v-text-field v-model.number="item.demod_frequency_mhz" type="Number" min="0.000" max="999.9999" step="0.0001" label="MHz:" :rules="[rules.emptyRules, rules.minNumber, rules.range74Number,rules.decimal74Number]" outlined></v-text-field> 
                                        </v-col>
                                        <v-col>
                                            <v-icon style="margin-top: 19px;" @click="removeDemodFrequency(idx)">mdi-close</v-icon>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" v-if="data.sensor_demod_frequency.length > 0">
                                            <span>*Please choose default with checkbox </span>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-btn style="width: 100%;" color="primary" @click="addDemodFrequency()">ADD</v-btn>
                                        </v-col>
                                    </v-row>
                                </div>
                            </v-col>
                         
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <a href="javascript: void(0)" class="a-aim-btn" style="width: 100%">
                            <span class="a-aim-btn__deco -top"></span>
                            <span class="a-aim-btn__deco -bottom"></span>
                            <span class="a-aim-btn__main" @click="save()">
                            <span class="a-aim-btn__main-text">SAVE</span>
                            </span>
                        </a>
                    </v-card-actions>
                </v-card>
            </v-col>
    
            <v-dialog v-model="previewDialog">
                <v-card>
                    <v-card-title primary-title>
                        <v-row>
                            <v-col>
                                Sensor Model: &nbsp;{{ data.model_name }}
                            </v-col>
                            <v-spacer/>
                            
                            <v-icon @click="previewDialog=false">mdi-close</v-icon>
                            
                        </v-row>
                    </v-card-title>
                    <v-card-title style="margin-top: -30px;">
                        <v-row>                
                            <v-col cols="12" xl="3" lg="3" md="3" sm="12">
                                
                                Analog gain<br/>
                                <v-row v-for="(item, idx) in data.sensor_capacitance" :key="idx">
                                    <v-icon style="font-size: 10px">mdi-window-minimize</v-icon>&nbsp;&nbsp;{{ item.analog_gain }} - {{ item.capacitance_fF}}<br/>
                                </v-row>
                                Demodulation frequency (MHz)<br/>
                                <v-row v-for="(item, idx) in data.sensor_demod_frequency" :key="idx">
                                    <v-icon style="font-size: 10px">mdi-window-minimize</v-icon>&nbsp;&nbsp;{{ item.demod_frequency_mhz }}<br/>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-title>
                </v-card>
            </v-dialog>
        </v-row>
    </v-container>
</template>
<script>
import bus from '../nav/bus'
import axios from 'axios'
import moment from 'moment'
var host_url = process.env.VUE_APP_HOST_URL

export default {
    filters: {
        moment: function (date) {
            return moment(date).format('YYYY-MM-DD HH:mm:ss');
        }
    },
    data(){
        return {
            // 管理表
            headers: [
                {text: 'Model name', align: 'start', value: 'model_name', width: 150},
                {text: 'Minor version', align: 'center', value: 'minor_version', width: 100},        
                {text: 'Detail', align: 'center', value: 'detail', width: 80},                
                {text: 'Internal Action', align: 'center', value: 'in_set', width: 250},  
                {text: 'External Action', align: 'center', value: 'ex_set', width: 100},              
                {text: 'Update_at', align: 'center', value: 'update_at', width: 200},
                {text: 'Created_at', align: 'center', value: 'created_at', width: 200},
            ],
            table_data: [
                // { 
                //     model_name: 'SR3',
                //     wave_length: '0.0',
                //     width: 0,
                //     height: 0,
                //     pixel_pitch: '0.0',
                // }
            ],
            // 檢查輸入值型態
            checkInteger: /^[-+]?\d+$/,
            checkDecimal31: /^[-+]?[0-9]{0,2}?(?:\.[0-9]{0,1})?$/,
            checkDecimal32: /^[-+]?[0-9]{0,1}?(?:\.[0-9]{0,2})?$/,
            checkDecimal74: /^[-+]?[0-9]{0,3}?(?:\.[0-9]{0,4})?$/,
            rules: {
                emptyRules: v => (v !== '') || 'This field cannot be empty',
                minNumber: v => v >= 0 || 'The minimum value is 0',
                min1Number: v => v >=1 || 'The minimum value is 1',
                percentMaxNumber: v => v <= 100 || 'The maximum value is 100',
                intNumber: v => this.checkInteger.test(v) || "Only integer number is acceptable",
                range31Number: v => v <= 99.9 || "Only value from 00.0 to 99.9 is acceptable",
                range32Number: v => v <= 9.99 || "Only value from 0.00 to 9.99 is acceptable",
                range74Number: v => (v >= -999.9999 && v <= 999.9999) || "Only value from -999.9999 to 999.9999 is acceptable",
                decimal31Number: v => this.checkDecimal31.test(v) || "This field will be rounded to XX.X",
                decimal32Number: v => this.checkDecimal32.test(v) || "This field will be rounded to X.XX",
                decimal74Number: v => this.checkDecimal74.test(v) || "This field will be rounded to XXX.XXXX",
            },
            // 查詢關鍵字
            search: '',

            // 編輯頁面
            checkDialog: false,
            name: 'Artilux',
            data: {
                model_name: '',
                sensor_capacitance: [],
                sensor_demod_frequency: [],
                created_at: new Date(),
                updated_at: new Date(),
            },
            
            edit_status: false,
            previewDialog: false,

            // 刪除
            delete_dialog: false,
            delete_sensor: '',
            delete_index: null,

            btn_loading: false,
        }
    },
    created(){
        this.getSensor()
        let check_search = this.$route.query.params
        // console.log(check_search)
        if(check_search){
            this.search = check_search
        }
    },
    mounted(){
        this.fresh_sensor()
    },
    methods:{
        initData(){
            this.data= {
                model_name: '',
                sensor_capacitance: [],
                sensor_demod_frequency: [],
                created_at: new Date(),
                updated_at: new Date(),
            }
            
        },
        getSensor(){
            axios.get(host_url+'itof/get_sensor/')
            .then(response => {
                let tmp = response.data
                if(tmp.status == true){
                    this.table_data = tmp.data  
                    console.log(this.table_data)
                }
                
            })
        },
        // Capacitance add and remove
        addCapacitance(){
            this.data.sensor_capacitance.push({
                sensor_model: this.data.id,
                analog_gain: "x",
                capacitance_fF: 0,
                default: false,
            })
        },
        removeCapacitance(idx){
            this.data.sensor_capacitance.splice(idx, 1)
        },
        // Demod Frequency add and remove
        addDemodFrequency(){
            this.data.sensor_demod_frequency.push({
                sensor_model: this.data.id,
                demod_frequency_mhz: 0,
                default: false
            })
        },
        removeDemodFrequency(idx){
            this.data.sensor_demod_frequency.splice(idx, 1)
        },
     
        update(item){
            this.data = item
            this.checkDialog = !this.checkDialog
        },
        detail(item){
            this.previewDialog = true
            this.data = item
            console.log(this.data)
        },
     
        chooseDefault(idx, type){
            if(type== 'capacitance'){
                for (let [i, key] of this.data.sensor_capacitance.entries()){
                    key.default = false
                }
                this.data.sensor_capacitance[idx].default = true
            }
            if(type == 'demod_frequency'){
                for (let [i, key] of this.data.sensor_demod_frequency.entries()){
                    key.default = false
                }
                this.data.sensor_demod_frequency[idx].default = true
            }
            
        },
        back(){
            this.getSensor()
            this.checkDialog = false
        },
        save(){
            // check model name not empty
            if(this.data.model_name == ''){ alert('Model name can not be empty'); return }
            // check all params value not empty
            let check_status = this.checkAllValues()
            if(check_status == false){
                alert('Please check every field is correct');
                return
            }
            // check capacitance must be add 
            if(this.data.sensor_capacitance.length == 0){
                alert('Please add one capacitance at least');
                return
            }
            // check capacitance choose default
            let check_capacitance_default = false
            for(let value of this.data.sensor_capacitance){
                if(value.default == true ){ check_capacitance_default = true}
            }
            if (check_capacitance_default == false){
                alert('Please choose default for capacitance')
                return 
            }

            // check demodulation must be add 
            if(this.data.sensor_demod_frequency.length == 0){
                alert('Please add one demodulation frequency at least');
                return
            }
            // check demodulation choose default
            let check_demod_default = false
            for(let value of this.data.sensor_demod_frequency){
                if(value.default == true ){ check_demod_default = true}
            }
            if (check_demod_default == false){
                alert('Please choose default for demodulation frequency')
                return 
            }
            console.log(this.data)
            axios.post(host_url+'itof/update_sensor/', this.data)
            .then(response => {
                let tmp = response.data
                if(tmp.status == true){
                    this.table_data = tmp.data    
                    console.log(this.table_data)
                    bus.$emit('alert', {msg: tmp.msg, title: "Hint",　check: "Got it"})
                    this.checkDialog = false;
                }
            })
            .catch((error) => {
                console.log(error)
                bus.$emit('alert', {msg: 'Update sensor error', title: "Hint",　check: "Got it"})
            })
                
                        
        },
        checkAllValues(){
            // 超過範圍給最大值, 小於範圍給最小值
            let check_status =true
            // check each value not be empty or null
            
            for(let [key, value] of Object.entries(this.data)){
           
                if(value === '' || value === null){
                    check_status = false
                }
            }
            let capacitance_count = 0
            for(let [key, value] of this.data.sensor_capacitance.entries()){
                
                if(value.analog_gain === ''){ check_status = false }
                if(value.capacitance_fF === '' || value.capacitance_fF < 0 || !this.checkInteger.test(value.capacitance_fF)){ check_status = false}
                capacitance_count += 1
            }
            let demod_count = 0
            for(let [key, value] of this.data.sensor_demod_frequency.entries()){
                value.demod_frequency_mhz = parseFloat(value.demod_frequency_mhz).toFixed(4)
                if(value.demod_frequency_mhz === '' || !this.checkDecimal74.test(value.demod_frequency_mhz) || value.demod_frequency_mhz < 0){ check_status = false }
                demod_count += 1
            }

            return check_status
        },

        activeSensor(item, active, type){
            console.log(item.id)
            axios.post(host_url+'itof/active_sensor/', {id: item.id, active: active, type: type})
            .then(response => {
                let tmp = response.data
                if(tmp.status == true){
                    this.table_data = tmp.data
                    console.log(tmp.data)
                    if(active == true){
                        bus.$emit('alert', {msg: tmp.msg, title: "Hint",　check: "Got it"})    
                    }                    
                }
                else{
                    bus.$emit('alert', {msg: tmp.msg, title: "Hint",　check: "Got it"})
                }
            })
            .catch(error => {
                console.log(error)
            })
        },
        fresh_sensor(){
            this.btn_loading = true
            axios.post(host_url+'itof/call_sensor_model_api/', {key: 'api_test'})
            .then(response => {
                let tmp = response.data
                console.log(tmp)
                if(tmp.status == true){
                    this.table_data = tmp.data
                    bus.$emit('alert', {msg: 'Update sensor model success', title: "Hint",　check: "Got it"})                                       
                }
                else{
                    if(tmp.status != 'No update'){
                        bus.$emit('alert', {msg: 'Update sensor model fail', title: "Hint",　check: "Got it"})
                    }                    
                }
            })
            .catch(error => {
                console.log(error)
            })

            setTimeout(() => {
                this.btn_loading = false;
            }, 2000);
        }
    }
}
</script>
<style scoped>
.borderStyle {
  border: 3px lightgray solid;
  margin-top: 30px;
  border-radius: 10px;
  padding: 10px;
}
</style>